import { render, staticRenderFns } from "./BackupRequestRollover.vue?vue&type=template&id=398b9a90&"
import script from "./BackupRequestRollover.vue?vue&type=script&lang=js&"
export * from "./BackupRequestRollover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports